import React, { FC, useMemo } from 'react';
import { ReactComponent as InfoIcon } from '@blink/assets/src/icons/infoCircle.svg';

type TipCardProps = {
    title: string;
    text: string;
};

export const TipCard: FC<TipCardProps> = ({ title, text }) => {
    const { titleId, descriptionId } = useMemo(() => {
        let titleId = '';
        let descriptionId = '';

        if (title) {
            titleId = title.toLowerCase().replace(/ /g, '-');
            titleId += '-title-tip-card';

            descriptionId = title.toLowerCase().replace(/ /g, '-');
            descriptionId += '-description-tip-card';
        }

        return { titleId, descriptionId };
    }, [title]);

    return (
        <div className='flex border border-gray-300 rounded-md px-5 py-4 gap-4'>
            <InfoIcon className='w-[20px] h-[24px]' />
            <div className='flex flex-col items-start gap-2 w-full'>
                <div className='flex'>
                    <div
                        className='text-[16px] font-medium leading-6 tracking-tight font-[Inter]'
                        data-testid={titleId}
                    >
                        {title}
                    </div>
                </div>
                <div
                    className='text-content-secondary text-md font-medium leading-5 tracking-tight font-[Inter]'
                    data-testid={descriptionId}
                >
                    {text}
                </div>
            </div>
        </div>
    );
};
